import { useState } from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Popover from '@mui/material/Popover'

type Props = {
  backgroundColor: string
  isGrootverbruik?: boolean
  isWachtlijst?: boolean
  isActive?: boolean
}

const flagCharDict = {
  isGrootverbruik: 'G',
  isWachtlijst: '||',
  isInActive: '✖',
}

const flagLabelDict = {
  isGrootverbruik: 'Grootverbruik aansluiting aanwezig',
  isWachtlijst: 'Minstens 1 aansluiting staat op de wachtlijst',
  isInActive: 'Minstens 1 aansluiting is inactief',
}

export const DisciplineIconFlagBadge = ({
  backgroundColor,
  isGrootverbruik,
  isWachtlijst,
  isActive,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const flags = {
    isWachtlijst,
    isGrootverbruik,
    isInActive: isActive === false,
  }
  const activeFlags = Object.keys(flags).filter(
    (key) => flags[key as keyof typeof flags],
  )

  const showFlagBadge = activeFlags.length > 0

  if (!showFlagBadge) {
    return null
  }

  const flagChar =
    activeFlags.length === 1
      ? flagCharDict[activeFlags[0] as keyof typeof flagCharDict]
      : '!'
  const handlePopoverOpen = (event) => setAnchorEl(event.currentTarget)
  const handlePopoverClose = () => setAnchorEl(null)

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          bottom: -4,
          right: -4,
          width: 20,
          height: 20,
          borderRadius: '100%',
          background: 'white',
          border: `1px solid ${backgroundColor}`,
          fontSize: '12px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: backgroundColor,
          lineHeight: '100%',
        }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {flagChar}
      </Box>

      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          '& .MuiPopover-paper': {
            p: 1,
            backgroundColor: 'rgba(97,97,97,.9)',
          },
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Grid>
          {activeFlags.map((flag) => (
            <Box key={flag} sx={{ color: 'white' }}>
              {flagLabelDict[flag as keyof typeof flagLabelDict]}
            </Box>
          ))}
        </Grid>
      </Popover>
    </>
  )
}
